module.exports = __webpack_public_path__ + "static/scale-model-of-cummer-museum-of-art-&-gardens-in-jacksonville-florida-e06155b60162448df470d141d5497431.png";